import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import { I18nProvider } from 'lingui-react';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import App from './App';

import { getMyAccount, createAccount } from './services/index';
import { Router } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import axios from 'axios';
import { KEYCLOAK_CONFIG, SENTRY_URL } from './settings';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap-grid.min.css';

import { unpackCatalog } from 'lingui-i18n';
import catalog from './locale/de/messages.js';
import Keycloak from 'keycloak-js';

import Cookies from 'universal-cookie';

// Sentry configuration
Sentry.init({
  dsn: SENTRY_URL,
  release: "1.9.5",
  integrations: [new Integrations.BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

const { detect } = require('detect-browser');
const browser = detect();

const history = createHistory();

const kc = new Keycloak({
  url: KEYCLOAK_CONFIG.auth_server_url,
  realm: KEYCLOAK_CONFIG.realm,
  clientId: KEYCLOAK_CONFIG.client_id
});

const publicPaths = ['/']
const currentPath = document.location.pathname;
if (publicPaths.indexOf(currentPath) !== -1) {
  kc.init({ onLoad: 'check-sso' }).then(authenticated => {
    // Add token to request header
    axios.interceptors.request.use(config => {
      config.headers = {
        ...config.headers, ...{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'bearer ' + kc.token
        }
      }
      if (browser.name === 'ie' && config.method === 'get') {
        if (config.url.indexOf('?') > -1) {
          config.url = config.url + '&version=' + Date.now().toString();
        } else {
          config.url = config.url + '?version=' + Date.now().toString();
        }
      }
      return config;
    });
    // Add a response interceptor
    axios.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      console.log('error.response.status', error.response.status)
      if (error.response.status === 401 || error.response.status === 403) {
        kc.login();
        return
      }
      return Promise.reject(error);
    });
    const dev = process.env.NODE_ENV !== 'production' ? require('lingui-i18n/dev') : undefined
    ReactDOM.render(
      <I18nProvider language="en" catalogs={{ de: unpackCatalog(catalog) }} development={dev}>
        <Router history={history}>
          <App history={history} keyCloak={kc} cookies={new Cookies()} />
        </Router>
      </I18nProvider>,
      document.getElementById('root'))
  });
} else {
  kc.init({ onLoad: 'check-sso' }).then(authenticated => {
    if (authenticated) {
      // Add token to request header
      axios.interceptors.request.use(config => {
        config.headers = {
          ...config.headers, ...{
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'bearer ' + kc.token
          }
        }
        if (browser.name === 'ie' && config.method === 'get') {
          if (config.url.indexOf('?') > -1) {
            config.url = config.url + '&version=' + Date.now().toString();
          } else {
            config.url = config.url + '?version=' + Date.now().toString();
          }
        }
        return config;
      });

      // Add a response interceptor
      axios.interceptors.response.use(function (response) {
        return response;
      }, function (error) {
        console.log('error.response.status', error.response.status)
        if (error.response.status === 401 || error.response.status === 403) {
          kc.logout();
          return
        }
        return Promise.reject(error);
      });

      // Get new token when expiring
      setInterval(() => {
        kc.updateToken(5).catch(() => kc.logout());
      }, 5000);

      getMyAccount().then(account => {
        if (account) {
          // Render DOM if authenticated
          //console.log('Render DOM if authenticated');
          const dev = process.env.NODE_ENV !== 'production' ? require('lingui-i18n/dev') : undefined
          ReactDOM.render(
            <I18nProvider language="en" catalogs={{ de: unpackCatalog(catalog) }} development={dev}>
              <Router history={history}>
                <App history={history} keyCloak={kc} account={account} cookies={new Cookies()} />
              </Router>
            </I18nProvider>,
            document.getElementById('root')
          );
        } else {
          kc.loadUserProfile().then(profile => {
            let kcProfile = profile;
            kcProfile['userId'] = kc.subject;
            createAccount({ keyCloakIdentity: kcProfile }).then(account => {
              // Render DOM if authenticated
              const dev = process.env.NODE_ENV !== 'production' ? require('lingui-i18n/dev') : undefined
              ReactDOM.render(
                <I18nProvider language="en" catalogs={{ de: unpackCatalog(catalog) }} development={dev}>
                  <Router history={history}>
                    <App history={history} keyCloak={kc} account={account} cookies={new Cookies()} />
                  </Router>
                </I18nProvider>,
                document.getElementById('root')
              );
            }).catch(err => console.log('Failed to create an new account :', err));
          }).catch(() => {
            console.log('Failed to load user profile');
          });
        }
      }).catch(err => {
        console.log('getAccounts', err);
      })

    } else {
      kc.login();
    }
  });
}







// WEBPACK FOOTER //
// ./src/index.js